import { combineReducers } from 'redux';

import { reducer as httpRequestReducer } from '@travel/http-request';
import { reducer as i18nReducer } from '@travel/i18n';

import authCodeReducer from './authCode/reducer';
import commonErrorReducer from './commonError/reducer';
import providerPlanListReducer from './providerPlan/reducer';
import userAgentReducer from './userAgent/reducer';

import routerReducer from './__router/reducer';

export default combineReducers({
  _i18n: i18nReducer,
  _httpRequest: httpRequestReducer,
  router: routerReducer,
  authCode: authCodeReducer,
  commonError: commonErrorReducer,
  userAgent: userAgentReducer,
  providerPlan: providerPlanListReducer,
});
